import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "./alternativeAppointmentPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";
import { useNavigate } from "react-router-dom";
import CloseButton from "../../closeButton/closeButton";
import { getDuration } from "../../../utils/utils";
import { TCalendarAppointment } from "../../../services/types/user.types";

interface IAlternativeAppointmentPopup extends IPopupWithoutProps {
    appointmentData: TCalendarAppointment;
}
function AlternativeAppointmentPopup({
    onClose,
    appointmentData,
}: IAlternativeAppointmentPopup) {
    const appointmentDate = new Date(appointmentData.appointmentDate)


    const navigate = useNavigate();

    return (
        <article className={popupStyles.popup}>
            <CloseButton onClick={onClose} />
            <h2 className={popupStyles.popup__title}>{t('ALTERNATIVE_MEETING_SUCCESS')}</h2>
            <img
                src={doctor}
                alt={t('IMAGE_OF_VENUS')}
                className={popupStyles.popup__img}
            />
            <p className={popupStyles.popup__text}>{t('NEW_MEETING_DATE')}</p>
            <p className={popupStyles.popup__text_big}>
                {`${appointmentDate.getDate()}/${appointmentDate.getMonth() + 1
                    }/${appointmentDate.getFullYear()}`}
            </p>
            <p className={popupStyles.popup__text}>{t('NEW_MEETING_TIME')}</p>
            <p className={popupStyles.popup__text_big}>
                {getDuration(appointmentDate, appointmentData.startTime ?? "00:00", appointmentData?.endTime ?? "00:50")}
            </p>
            <p className={popupStyles.popup_text_info}>
                {t('MEETING_SCHEDULE_ACCESS_1')}</p>

            <button
                className={`button ${popupStyles.popup__btn} ${popupStyles.popup__btn_type_calendar} hover`}
                onClick={() => {
                    navigate("/treatment", {
                        replace: true,
                        state: { pathname: "myCalendar" },
                    });
                    onClose();
                }}
            >
                {t('MEETING_CALENDAR_AREA')}</button>
            <button
                className={`button ${popupStyles.popup__btn} ${popupStyles.popup__btn_disabled} hover`}
                onClick={() => {
                    navigate("/treatment/search");
                    onClose();
                }}
                disabled={true}
            >
                {t('SCHEDULE_ANOTHER_MEETING')}</button>
        </article>
    );
}

export default AlternativeAppointmentPopup;
